<template lang="pug">
	.element-properties(:style="{zIndex: dragProcess ? 2000 : 2}")
		.cursor-container(v-if="dragProcess" :style="{cursor: ({x: 'ew-resize', y: 'ns-resize', 'xy': 'move'})[dragProcess.propertyModifier]}")
		.header-container(v-if="element")
			.drag-header(v-if="getChangeProcess()")
				small.tutorial-text-header {{getChangeProcess().messages.dragProcess}}
				br
				small.tutorial-text-description(v-if="getChangeProcess().shiftKey && getChangeProcess().ctrlKey") {{getChangeProcess().messages.shiftCtrlOption}}
				small.tutorial-text-description(v-else-if="getChangeProcess().shiftKey") {{getChangeProcess().messages.shiftOption}}
				small.tutorial-text-description(v-else-if="getChangeProcess().ctrlKey") {{getChangeProcess().messages.ctrlOption}}
				small.tutorial-text-description.text-muted(v-else) {{getChangeProcess().messages.optionsProposal}}
			.default-header(v-else)
				.name(v-if="element.type === 'global'") Global properties
				.name(v-else-if="element.type === 'root-container'") Scene properties
				.name(v-else) Element properties
				.description.text-muted(v-if="element.type === 'text'") Double-click on text in preview frame to edit it
			.revert-button(v-if="_.size(changedProperties) > 0" v-on:click="revertProperties()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Revert all changes in properties'}")
				.fa.fa-rotate-left
		.props-container.main-props(v-if="element")
			.prop-item(v-for="prop in props" v-if="prop.options['main']" :class="{'change-process': `${element.codename}-${prop.codename}` in changedValues}")
				.title(v-b-tooltip.hover="{delay: {show: 1500, hide: 100 }, title: prop.description}") {{prop.title || prop.codename}}
				.control
					.control-dropdown-asset-image(v-if="prop.options.control === 'EditorPropertyImage'")
						EditorPropertyImage(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
					.control-dropdown-localization-text(v-if="prop.options.control === 'EditorPropertyText'")
						EditorPropertyText(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.textCodename)")
					.control-dropdown-asset-video(v-if="prop.options.control === 'EditorPropertyVideo'")
						EditorPropertyVideo(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
					.control-dropdown-asset-spine(v-if="prop.options.control === 'EditorPropertySpine'")
						EditorPropertySpine(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
					.control-dropdown-asset-sprite-animation(v-if="prop.options.control === 'EditorPropertySpriteAnimation'")
						EditorPropertySpriteAnimation(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
				.options
					.option.localization(v-if="prop.options.control === 'EditorPropertyText' && getDisplayedValue(prop)" v-on:click="openLocalization(getDisplayedValue(prop))" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Open in localization'}")
						.fa.fa-external-link-square
					.option.restore(v-if="changedProperties[prop.codename]" v-on:click="revertProperty(prop)")
						.fa.fa-rotate-left
					.option.remove(v-if="!prop.options['displayAlways']" v-on:click="removeProperty(prop)")
						.fa.fa-remove
					.option.split(v-if="canSplitProperty(prop)" v-on:click="togglePropertySplitState(prop)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Use different values for portrait and landscape orientations'}")
						.fa(:class="isPropertySplit(prop) ? 'fa-compress' : 'fa-expand'")
		.props-container.typical-props(v-if="element")
			.prop-item(v-for="prop in props" v-if="(prop.options['displayAlways'] || elementProps.hasOwnProperty(prop.codename)) && !prop.options['main']" :class="{'change-process': `${element.codename}-${prop.codename}` in changedValues}")
				.title(v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: prop.description}") {{prop.title || prop.codename}}
				.control
					// Почти такой же код с перечислением контролов находится в файле AnimationSteps.vue добавляя что-то сюда вероятно нужно добавить и туда. Разница в параметрах существенная: другой default, value, options и theme, но сам список контролов должен совпадать
					.control-dropdown-asset-image(v-if="prop.options.control === 'EditorPropertyImage'")
						EditorPropertyImage(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
					.control-dropdown-localization-text(v-if="prop.options.control === 'EditorPropertyText'")
						EditorPropertyText(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.textCodename)")
					.control-dropdown-asset-video(v-if="prop.options.control === 'EditorPropertyVideo'")
						EditorPropertyVideo(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
					.control-dropdown-asset-spine(v-if="prop.options.control === 'EditorPropertySpine'")
						EditorPropertySpine(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
					.control-dropdown-asset-sprite-animation(v-if="prop.options.control === 'EditorPropertySpriteAnimation'")
						EditorPropertySpriteAnimation(:value="getDisplayedValue(prop)" v-on:change="changeValueBySelect(prop, $event.assetCodename)")
					.control-dropdown-spine-option(v-if="prop.options.control === 'EditorPropertySpineOption'")
						EditorPropertySpineOption(:value="getDisplayedValue(prop)" :element="element" :list="prop.options.controlOptions?.list" v-on:change="changeValueBySelect(prop, $event.name)")
					.control-range(v-if="prop.options.control === 'InputRange'")
						InputRange(v-on:change="changeValueByInput(prop, $event, null, null, true)" v-on:input="changeValueByInput(prop, $event)" :default="prop['default']" :value="(prop.codename in elementProps) ? elementProps[prop.codename] : null" :type="prop.type" :options="prop.options" theme="dark-mini")
					.control-number(v-else-if="prop.options.control === 'Select'")
						Select(v-on:change="changeValueByInput(prop, $event, null, $event)" :default="prop['default']" :value="(prop.codename in elementProps) ? elementProps[prop.codename] : null" :values="prop['options']['values']" :type="prop.type" theme="dark-mini")
					.control-coords(v-else-if="prop.options.control === 'InputCoordsDrag'")
						InputCoordsDrag(v-on:change="changeValueByInput(prop, $event, 'xy', null, true)" v-on:input="changeValueByInput(prop, $event)" v-on:startDragProcess="startDragProcess" v-on:stopDragProcess="stopDragProcess" :default="prop['default']" :value="(prop.codename in elementProps) ? elementProps[prop.codename] : null" :options="prop.options" theme="dark-mini")
					.control-coords(v-else-if="prop.options.control === 'InputNumberDrag'")
						InputNumberDrag(v-on:change="changeValueByInput(prop, $event, 'xy', null, true)" v-on:input="changeValueByInput(prop, $event)" v-on:startDragProcess="startDragProcess" v-on:stopDragProcess="stopDragProcess" :default="prop['default']" :value="(prop.codename in elementProps) ? elementProps[prop.codename] : null" :options="prop.options" theme="dark-mini")
					.control-coords(v-else-if="prop.options.control === 'InputAngle'")
						InputAngle(v-on:change="changeValueByInput(prop, $event, 'xy', null, true)" v-on:input="changeValueByInput(prop, $event)" v-on:startRotation="startRotation" v-on:stopRotation="stopRotation" :default="prop['default']" :value="(prop.codename in elementProps) ? elementProps[prop.codename] : null" :options="prop.options" theme="dark-mini")
					.control-boolean(v-else-if="prop.options.control === 'InputSwitch'")
						InputSwitch(v-on:change="changeValueByInput(prop, $event, 'xy', null, true)" v-on:input="changeValueByInput(prop, $event)" :default="prop['default']" :value="(prop.codename in elementProps) ? elementProps[prop.codename] : null" :options="prop.options" theme="dark-mini")
				.options
					.option.localization(v-if="prop.options.control === 'EditorPropertyText' && getDisplayedValue(prop)" v-on:click="openLocalization(getDisplayedValue(prop))" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Open in localization'}")
						.fa.fa-external-link-square
					.option.restore(v-if="changedProperties[prop.codename]" v-on:click="revertProperty(prop)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Revert property value to default'}")
						.fa.fa-rotate-left
					.option.remove(v-if="!prop.options['displayAlways']" v-on:click="removeProperty(prop)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Remove property'}")
						.fa.fa-remove
					.option.global(v-if="Version.SelectedVersion?.options?.sizes?.length > 1" v-on:click="toggleGlobalPropertyState(prop)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Use the same value for all creative sizes'}")
						.fa(:class="isPropertyGlobal(prop) ? 'fa-lock' : 'fa-unlock-alt'")
					.option.split(v-if="canSplitProperty(prop)" v-on:click="togglePropertySplitState(prop)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Use different values for portrait and landscape orientations'}")
						.fa(:class="isPropertySplit(prop) ? 'fa-compress' : 'fa-expand'")
			.properties-controls
				.dropdown-element-property(@click="openPropertyAddMenu($event)")
					.value Add property
					.drop-icon.fa.fa-caret-down
				EditorElementActions(v-if="element.type !== 'global' && element.type !== 'root-container'" :element="element")
</template>

<script>

	import Screen 							from './../../mixins/screen'

	import { Creative }						from './../../services/Creative'
	import { Elements }						from './../../services/Elements'
	import { Layout }						from './../../services/Layout'
	import { Localization }					from './../../services/Localization'

	import EditorElementInfoPropertiesAdd	from './../Editor/EditorElementInfoPropertiesAdd'
	import EditorElementActions				from './../Editor/EditorElementActions'

	import EditorPropertyImage				from './../Editor/Controls/EditorPropertyImage'
	import EditorPropertyText				from './../Editor/Controls/EditorPropertyText'
	import EditorPropertyVideo				from './../Editor/Controls/EditorPropertyVideo'
	import EditorPropertySpine				from './../Editor/Controls/EditorPropertySpine'
	import EditorPropertySpineOption		from './../Editor/Controls/EditorPropertySpineOption'
	import EditorPropertySpriteAnimation	from './../Editor/Controls/EditorPropertySpriteAnimation'
	import InputRange						from './../Editor/Controls/InputRange'
	import Select							from './../Editor/Controls/Select'
	import InputCoordsDrag					from './../Editor/Controls/InputCoordsDrag'
	import InputNumberDrag					from './../Editor/Controls/InputNumberDrag'
	import InputAngle						from './../Editor/Controls/InputAngle'
	import InputSwitch						from './../Editor/Controls/InputSwitch'

	export default {
		name: 'EditorElementInfoProperties',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Preview Size Changed",
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched"
			],
			events: {
				"Selected Element Property Changed,Selected Element Changed: [options.globals|options.portraitLandscape]": function(element, oldElement, propertyCodename) {

					this.update();

				},
				"IFrame Data:ElementProperty": function(data) {

					if (data.elementCodename === this.element.codename) this.setValue(data.propertyName, data.propertyValue);

				},
				"IFrame Data:StartElementDrag": function(elementCodename) {

					if (elementCodename === this.element.codename) this.iFrameDragProcess = {messages: Metadata.ElementPropertiesByCodename['position'].options.messages}

				},
				"IFrame Data:ElementDrag": function(data) {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess.shiftKey = data.shiftKey;
						this.iFrameDragProcess.ctrlKey = data.ctrlKey;

						this.update();

					}

				},
				"IFrame Data:EndElementDrag": function() {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess = null;

					}

				},
				"IFrame Data:StartElementScale": function(elementCodename) {

					if (elementCodename === this.element.codename) this.iFrameDragProcess = {messages: Metadata.ElementPropertiesByCodename['scale'].options.messagesIFrame}

				},
				"IFrame Data:ElementScale": function(data) {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess.shiftKey = data.shiftKey;
						this.iFrameDragProcess.ctrlKey = data.ctrlKey;

						this.update();

					}

				},
				"IFrame Data:EndElementScale": function() {

					if (this.iFrameDragProcess) {

						this.iFrameDragProcess = null;

					}

				}
			}
		},
		components: {
			EditorPropertyImage,
			EditorPropertyText,
			EditorPropertyVideo,
			EditorPropertySpine,
			EditorPropertySpineOption,
			EditorPropertySpriteAnimation,
			EditorElementInfoPropertiesAdd,
			EditorElementActions,

			InputRange,
			Select,
			InputCoordsDrag,
			InputNumberDrag,
			InputAngle,
			InputSwitch
		},
		props: [],
		data() {

			this.element = null;
			this.elementProps = {};

			this.templateProperties = {};
			this.changedProperties = {};

			this.props = [];

			this.dragProcess = null;
			this.dragProcessExternal = null;
			this.keyPressProcess = null;
			this.iFrameDragProcess = null;
			this.rotateProcess = null;

			return {
				showed: true,
				changedValues: {},
				deleteButtonHovering: false,
				parentStyles: {},
			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragProcess) this.stopDrag();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragProcess) this.processDrag(e);

			});

			window.addEventListener("keydown", e => {

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = true;
					if (this.dragProcess) this.dragProcess.shiftKey = true;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = true;
					if (this.dragProcess) this.dragProcess.ctrlKey = true;

					this.update();

				}

			});

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess && (e.keyCode === 38 || e.keyCode === 40)) this.stopChangeValueByKeyPress();

				if (e.keyCode === 16) {

					if (this.keyPressProcess) this.keyPressProcess.shiftKey = false;
					if (this.dragProcess) this.dragProcess.shiftKey = false;

					this.update();

				}

				if (e.keyCode === 17) {

					if (this.keyPressProcess) this.keyPressProcess.ctrlKey = false;
					if (this.dragProcess) this.dragProcess.ctrlKey = false;

					this.update();

				}

			});

		},
		methods: {
			collectData() {

				this.version = Version.SelectedVersion;
				if (!this.version) return;
				this.element = Elements.SelectedElement;
				if (!this.element) return;

				// Если отображаются глобальные свойства, анимации и события
				if (this.element.codename === "#global") {

					this.elementProps = {};

					this.props = {};

					this.templateProperties = {};

				} else {

					this.elementProps = this.element?.props?.[Layout.getPreviewSizeKey()] || {};

					// Свойства, разделённые на портретное и ландшафтное значения (options.portraitLandscape), разворачиваются
					// в две строки с пометками p / l, остальные свойства отображаются как обычно одной строкой
					let elementProperties = _.filter(_.orderBy(Metadata.ElementProperties, 'priority'), propertyParams => propertyParams.active && (!propertyParams.options.elementTypes || _.includes(propertyParams.options.elementTypes, this.element?.type)));

					this.props = [];

					_.each(elementProperties, propertyParams => {

						if (this.isPropertySplit(propertyParams)) {

							this.props.push(this.getOrientedPropertyParams(propertyParams, 'portrait'));
							this.props.push(this.getOrientedPropertyParams(propertyParams, 'landscape'));

						} else {

							this.props.push(propertyParams);

						}

					});

					this.templateProperties = {};

					// TODO: в будущем тут нужно будет добавить варианты для экрана загрузки, конечных карточек, видео плееблов
					if (Creative.SelectedCreative.type === 'end-card') this.templateProperties = Metadata.TemplateEndCardElementsByEndCardByCodename[Creative.SelectedCreative?.options?.endCardId]?.[this.element["screen_codename"]]?.[this.element.codename]?.props?.[Layout.getPreviewSizeKey()] || {};
					else if (Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'storyboard' || Creative.SelectedCreative.type === 'editable-playable') {
						let templateId = Version.SelectedVersion?.options?.templateId;
						this.templateProperties = Metadata.TemplateElementsByTemplateByCodename[templateId]?.[this.element["screen_codename"]]?.[this.element.codename]?.props?.[Layout.getPreviewSizeKey()] || {};
					}

					// console.log('collectData this.templateProperties', this.templateProperties, this.element);

					// Вычислим, какие свойства были изменены относительно шаблона
					this.changedProperties = {};

					if (this.version?.options?.templateId) {

						_.each(this.elementProps, (elementPropertyValue, propertyCodename) => {

							// Если это свойство из шаблона и оно было изменено относительно шаблона
							if (propertyCodename in this.templateProperties && !_.isEqual(this.templateProperties[propertyCodename], elementPropertyValue)) this.changedProperties[propertyCodename] = true;
							// Если это свойство не ищз шаблона и оно было изменено относительно значения по умолчанию для этого свойства
							else if (!(propertyCodename in this.templateProperties) && elementPropertyValue !== undefined && !_.isEqual(Metadata.ElementPropertiesByCodename[propertyCodename]?.default, elementPropertyValue)) this.changedProperties[propertyCodename] = true;

						});

						_.each(this.templateProperties, (templatePropertyValue, propertyCodename) => {

							// Если свойство из шаблона и оно было удалено из версии креатива
							if (!(propertyCodename in this.elementProps)) this.changedProperties[propertyCodename] = true;

						});

					}

				}


			},
			// Базовый codename свойства (без суффикса ориентации)
			getBasePropertyCodename(propertyParams) {

				return propertyParams?.baseCodename || propertyParams?.codename;

			},
			// Разделено ли свойство на портретное и ландшафтное значения
			isPropertySplit(propertyParams) {

				return !!this.element?.options?.portraitLandscape?.[this.getBasePropertyCodename(propertyParams)];

			},
			// Может ли свойство быть разделено на портретное и ландшафтное значения.
			// Разделение доступно для креативов, элементы которых редактируются в редакторе с размерами
			// (баннеры, сториборды, конечные карточки, редактируемые плейаблы).
			// Переключатель показывается только у первой (портретной) строки свойства, чтобы не дублировался
			canSplitProperty(propertyParams) {

				if (!['banner', 'storyboard', 'end-card', 'editable-playable'].includes(Creative.SelectedCreative?.type)) return false;

				return !propertyParams.orientation || propertyParams.orientation === 'portrait';

			},
			// Параметры свойства для конкретной ориентации: codename получает суффикс (position -> positionPortrait)
			getOrientedPropertyParams(propertyParams, orientation) {

				let baseCodename = this.getBasePropertyCodename(propertyParams);
				let suffix = orientation === 'landscape' ? 'Landscape' : 'Portrait';
				let title = propertyParams.title || propertyParams.codename;

				return _.extend({}, propertyParams, {
					codename: baseCodename + suffix,
					baseCodename,
					orientation,
					title: `${title} (${orientation === 'landscape' ? 'l' : 'p'})`
				});

			},
			// Параметры свойства по codename. Если пришёл базовый codename разделённого свойства (например при
			// драге в превью) - берём строку текущей ориентации превью, чтобы изменение попало в нужное значение
			getPropertyParamsByCodename(codename) {

				let propertyParams = _.find(this.props, propertyParams => propertyParams.codename === codename);
				if (propertyParams) return propertyParams;

				let basePropertyParams = Metadata.ElementPropertiesByCodename[codename];

				if (basePropertyParams && this.isPropertySplit(basePropertyParams)) {

					let orientation = Layout.getPreviewSizeOrientation();
					let suffix = orientation === 'landscape' ? 'Landscape' : 'Portrait';
					let orientedCodename = this.getBasePropertyCodename(basePropertyParams) + suffix;

					return _.find(this.props, propertyParams => propertyParams.codename === orientedCodename) || basePropertyParams;

				}

				return basePropertyParams;

			},
			getDisplayedValue(propertyParams, propertyModifier = null) {

				if (!this.element) return null;

				let changedValueKey = `${this.element.codename}-${propertyParams.codename}`;

				let value = null;

				if (changedValueKey in this.changedValues) value = this.changedValues[changedValueKey];
				else if (propertyParams.codename in this.elementProps) value = this.elementProps[propertyParams.codename];
				else value = '';

				if (propertyModifier === 'x') value = value[0];
				else if (propertyModifier === 'y') value = value[1];

				return value;

			},
			getValue(propertyParams, propertyModifier = null) {

				let changedValueKey = `${this.element.codename}-${propertyParams.codename}`;

				let value = null;

				if (changedValueKey in this.changedValues) value = this.changedValues[changedValueKey];
				else if (this.elementProps[propertyParams.codename]) value = this.elementProps[propertyParams.codename];
				else return propertyParams.default;

				value = this.restoreValueType(propertyParams, value);

				if (propertyModifier === 'x') value = value[0];
				else if (propertyModifier === 'y') value = value[1];

				return value;

			},
			setValue(propertyName, propertyValue, fixAccuracy = true, forceUpdate = false) {

				let propertyParams = this.getPropertyParamsByCodename(propertyName);

				// Для разделённого свойства базовый codename заменяем на codename нужной ориентации,
				// чтобы значение записалось именно в портретное или ландшафтное свойство
				if (propertyParams?.codename) propertyName = propertyParams.codename;

				let changedValueKey = `${this.element.codename}-${propertyName}`;

				if (propertyParams.type === 'coords') {

					if (fixAccuracy) this.changedValues[changedValueKey] = [propertyValue[0].toFixed(propertyParams.options.changes.accuracy), propertyValue[1].toFixed(propertyParams.options.changes.accuracy)];
					else this.changedValues[changedValueKey] = propertyValue;

				} else if (propertyParams.type === 'number') {

					if ("max" in propertyParams.options.changes)
						if (propertyValue > propertyParams.options.changes.max) propertyValue = propertyParams.options.changes.max;

					if ("min" in propertyParams.options.changes)
						if (propertyValue < propertyParams.options.changes.min) propertyValue = propertyParams.options.changes.min;

					if (fixAccuracy) this.changedValues[changedValueKey] = propertyValue.toFixed(propertyParams.options.changes.accuracy);
					else this.changedValues[changedValueKey] = propertyValue;

				} else if (propertyParams.type === 'boolean') {

					this.changedValues[changedValueKey] = !!propertyValue;

				} else {

					this.changedValues[changedValueKey] = propertyValue;

				}

				if (forceUpdate) this.$forceUpdate();
				else this.update();

				this.sendPropertyValueToServer(this.element, propertyName, this.getValue(propertyParams));

			},
			restoreValueType(propertyParams, value) {

				if (propertyParams.type === 'coords') value = [parseFloat(value[0]), parseFloat(value[1])];
				if (propertyParams.type === 'number') value = parseFloat(value);

				return value;

			},
			sendPropertyValueToServer(element, propertyName, propertyValue) {

				let timeoutKey = `${element['version_id']}-${element['screen_codename']}-${element['codename']}-${propertyName}`;

				//this.elementProps[propertyName] = propertyValue;

				Server.sendWithTimeout({
					SetElementProperty: {
						elementId: element.id,
						elementPropertyCodename: propertyName,
						elementPropertyValue: propertyValue,
						sizeKey: Layout.getPreviewSizeKey()
					}
				}, timeoutKey, 500);

				Broadcast.once(`Selected Version Element Property Changed: [${propertyName}]`, () => {

					delete this.changedValues[`${element.codename}-${propertyName}`];

					this.update();

				});

			},
			isDisplayedValueChanged(propertyParams, propertyModifier) {

				let changedValueKey = `${this.element.codename}-${propertyParams.codename}`;

				if (!(changedValueKey in this.changedValues)) return false;

				let changedValue = this.changedValues[changedValueKey];

				changedValue = this.restoreValueType(propertyParams, changedValue);

				if (propertyModifier === 'x') changedValue = changedValue[0];
				if (propertyModifier === 'y') changedValue = changedValue[1];

				let baseValue = propertyParams.default;
				if (this.elementProps[propertyParams.codename]) baseValue = this.elementProps[propertyParams.codename];

				baseValue = this.restoreValueType(propertyParams, baseValue);

				if (propertyModifier === 'x') baseValue = baseValue[0];
				if (propertyModifier === 'y') baseValue = baseValue[1];

				return JSON.stringify(changedValue) !== JSON.stringify(baseValue);

			},
			getChangeProcess() {

				return this.dragProcess || this.iFrameDragProcess || this.rotateProcess || this.dragProcessExternal;

			},
			changeValueByInput(propertyParams, value, propertyModifier = null, e = null, isSave = true) {

				//console.log('changeValueByInput', value, propertyParams);

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					let changedValueKey = `${this.element.codename}-${propertyParams.codename}`;

					if (propertyParams.options.control === "InputCoordsDrag") {


					} else if (propertyParams.type === 'coords' && propertyParams.options.control !== "InputCoordsDrag") {

						// Если вводить значение "0.3" то при написании второго символа "0." код обновляет поле ввода назад на "0" и становится невозможно ввести "0.3" поэтому пропустим тут обновление при временно невалидных значениях
						if (parseFloat(value) + '' !== value + '') return;

						value = parseFloat(value);

						if (_.isNaN(value)) {

							value = undefined;

						} else {

							let newValue = this.getValue(propertyParams);

							newValue[propertyModifier === 'x' ? 0 : 1] = value;

							value = newValue;

						}

					} else if (propertyParams.type === 'number') {

						// Если вводить значение "0.3" то при написании второго символа "0." код обновляет поле ввода назад на "0" и становится невозможно ввести "0.3" поэтому пропустим тут обновление при временно невалидных значениях
						if (parseFloat(value) + '' !== value + '') return;

						value = parseFloat(value);

						if (_.isNaN(value)) value = undefined;

					} else if (propertyParams.type === 'boolean') {

						value = !!value;

					}

					if (value !== undefined) {

						this.changedValues = {};
						this.changedValues[changedValueKey] = value;

						if (isSave) this.setValue(propertyParams.codename, value, false);

						this.sendValueToIFrame(propertyParams, value);

					}

				}

			},
			changeValueBySelect(propertyParams, value, isSave = true) {

				let changedValueKey = `${this.element.codename}-${propertyParams.codename}`;

				if (value !== undefined) {

					this.changedValues = {};
					this.changedValues[changedValueKey] = value;

					if (isSave) this.setValue(propertyParams.codename, value, false);

					this.sendValueToIFrame(propertyParams, value);

				}

			},
			startChangeValueByKeyPress(propertyParams, propertyModifier, e) {

				let propertyName = propertyParams.codename;

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							propertyName: propertyName,
							propertyModifier: propertyModifier,
							propertyParams: propertyParams,
							increaser: e.keyCode === 40 ? -1 : 1,
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeValue(this.keyPressProcess.propertyParams, this.keyPressProcess.propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							this.keyPressProcess.interval = setInterval(() => {

								this.changeValue(this.keyPressProcess.propertyParams, this.keyPressProcess.propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

							}, 50);

						}, 200);

						this.changeValue(this.keyPressProcess.propertyParams, this.keyPressProcess.propertyModifier, this.keyPressProcess.increaser, this.keyPressProcess.shiftKey, true);

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);
					clearTimeout(this.keyPressProcess.stopTimeout);

					this.keyPressProcess = null;

				}

			},
			processChangeValueByMouseWheel(propertyParams, propertyModifier, e) {

				this.changeValue(propertyParams, propertyModifier, Math.sign(e.wheelDelta), e.shiftKey, true);

			},
			startDrag(propertyParams, propertyModifier, e) {

				let propertyName = propertyParams.codename;

				this.dragProcess = {
					active: false,
					propertyName: propertyName,
					propertyModifier: propertyModifier,
					propertyParams: propertyParams,
					messages: propertyParams.options.messages,
					downPointerPosition: {
						x: e.clientX,
						y: e.clientY
					},
					downElementWidth: this.getValue(Metadata.ElementPropertiesByCodename['width']),
					downElementHeight: this.getValue(Metadata.ElementPropertiesByCodename['height']),
					downElementPosition: this.getValue(Metadata.ElementPropertiesByCodename['position'], 'xy'),
					downElementScale: this.getValue(Metadata.ElementPropertiesByCodename['scale'], 'xy'),
					downElementSkew: this.getValue(Metadata.ElementPropertiesByCodename['skew'], 'xy'),
					downElementOrigin: this.getValue(Metadata.ElementPropertiesByCodename['origin'], 'xy')
				};

				this.update();

			},
			processDrag(e) {

				if (this.dragProcess.active) {

					let offsetX = (e.clientX - this.dragProcess.downPointerPosition.x),
						offsetY = (e.clientY - this.dragProcess.downPointerPosition.y);

					if (this.dragProcess.propertyModifier === 'x') offsetY = 0;
					if (this.dragProcess.propertyModifier === 'y') offsetX = 0;

					if (this.dragProcess.propertyName === 'width' || this.dragProcess.propertyName === 'height') {

						let offset = this.dragProcess.propertyName === 'width' ? offsetX : offsetY;

						if (offset < 0) offset = 0;

						if (e.shiftKey && e.ctrlKey) {

							offset = Math.round(angle / 5) * 5;

						} else if (e.shiftKey) {

							offset = Math.round(angle / 50) * 50;

						} else if (e.ctrlKey) {

							offset = Math.round(angle / 20) * 20;

						}

						this.setValue(this.dragProcess.propertyParams.codename, offset);

					}

					this.update();

					this.sendValueToIFrame(this.dragProcess.propertyParams);

				} else {

					let dx = e.clientX - this.dragProcess.downPointerPosition.x,
						dy = e.clientY - this.dragProcess.downPointerPosition.y;

					this.dragProcess.active = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > 3;

				}

			},
			stopDrag() {

				this.dragProcess = null;

				this.update();

			},
			startDragProcess(dragProcess) {

				this.dragProcessExternal = dragProcess;

				this.update();

			},
			stopDragProcess() {

				this.dragProcessExternal = null;

				this.update();

			},
			startRotation(rotateProcess) {

				this.rotateProcess = rotateProcess;

				this.update();

			},
			stopRotation() {

				this.rotateProcess = null;

			},
			changeValue(propertyParams, propertyModifier, increaser, shiftKey, forceUpdate = false) {

				let changedValueKey = `${this.element.codename}-${propertyParams.codename}`;

				let propertyName = propertyParams.codename;

				if (!(changedValueKey in this.changedValues)) this.changedValues[changedValueKey] = _.cloneDeep((propertyName in this.elementProps) ? this.elementProps[propertyName] : propertyParams.default);

				if (propertyParams.type === 'coords') {

					let newValue = [parseFloat(this.changedValues[changedValueKey][0]), parseFloat(this.changedValues[changedValueKey][1])];

					newValue[propertyModifier === 'x' ? 0 : 1] += propertyParams.options.changes.step[propertyModifier === 'x' ? 0 : 1] * increaser * (shiftKey ? 10 : 1);

					this.setValue(propertyParams.codename, newValue, false, forceUpdate);

				} else if (propertyParams.type === 'number') {

					let newValue = parseFloat(this.changedValues[changedValueKey]);

					newValue += propertyParams.options.changes.step * increaser * (shiftKey ? 10 : 1);

					this.setValue(propertyParams.codename, newValue, false, forceUpdate);

				}

				this.sendValueToIFrame(propertyParams);

			},
			// Глобально ли свойство (у редактируемых плейаблов все свойства глобальные по умолчанию - см. Element.checkGlobalProperty)
			isPropertyGlobal(propertyParams) {

				let globalOption = this.element?.options?.globals?.[this.getBasePropertyCodename(propertyParams)];

				if (globalOption === true) return true;
				if (globalOption === false) return false;

				if (Creative.SelectedCreative?.type === 'editable-playable') return true;

				return !!propertyParams.options?.globalByDefault;

			},
			sendValueToIFrame(propertyParams, value = null) {

				if (value === null || value === undefined) {

					// Только если это свойство есть у элемента - отправляем его локальные изменения или дефолтное значение - иначе отправляем null
					if (this.elementProps[propertyParams.codename]) value = this.getValue(propertyParams);
					else value = null;

				}

				let propertyName = propertyParams.codename;

				// Значение разделённого свойства применяем в превью под базовым codename (именно его использует код креатива),
				// но только если редактируется значение текущей ориентации превью - значение другой ориентации в текущем
				// размере не отображается
				if (propertyParams.orientation) {

					if (propertyParams.orientation !== Layout.getPreviewSizeOrientation()) return;

					propertyName = this.getBasePropertyCodename(propertyParams);

				}

				Broadcast.call("Send To iFrame", [{
					ElementProperty: {
						screenCodename: this.element['screen_codename'],
						elementCodename: this.element.codename,
						propertyName: propertyName,
						propertyValue: value,
						sizeKey: Layout.getPreviewSizeKey()
					}
				}]);

			},
			normalizeCoords(x, y, propertyParams) {

				if (propertyParams.options.snap.horizontal) {

					if (Math.abs(y) < propertyParams.options.snap.horizontal) y = 0;

				}

				if (propertyParams.options.snap.vertical) {

					if (Math.abs(x) < propertyParams.options.snap.vertical) x = 0;

				}

				if (propertyParams.options.snap.center) {

					if (Math.abs(x) < propertyParams.options.snap.center && Math.abs(y) < propertyParams.options.snap.center) {

						x = 0; y = 0;

					}

				}

				return [x, y];

			},
			removeProperty(propertyParams) {

				/*Broadcast.call('Show Confirm', [{
					caption: propertyParams.options['displayAlways'] ? 'Clean element property' : 'Remove element property',
					message: propertyParams.options['displayAlways'] ? `Are you sure you want to clean element property "${propertyParams.title}"?` : `Are you sure you want to remove element property "${propertyParams.title}"? You will have possibility to add it again later.`,
					confirmButtonText: propertyParams.options['displayAlways'] ? '&nbsp;&nbsp;Clean property' : '&nbsp;&nbsp;Remove property',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {*/
						Server.sendToSocket({
							RemoveElementProperty: {
								elementId: this.element.id,
								elementPropertyCodename: propertyParams.codename,
								sizeKey: Layout.getPreviewSizeKey()
							}
						});
					/*}
				}]);*/

			},
			revertProperties() {

				Broadcast.call('Show Confirm', [{
					caption: 'Revert all properties changes',
					message: `Are you sure you want to revert all properties changes to the template state?`,
					confirmButtonText: '&nbsp;&nbsp;Revert all properties',
					confirmButtonIcon: 'fa-rotate-left',
					confirmCallback: () => {

						Server.sendToSocket({
							RevertElementProperties: {
								elementId: this.element.id,
								sizeKey: Layout.getPreviewSizeKey()
							}
						});

					}
				}]);

			},
			revertProperty(propertyParams) {

				/*Broadcast.call('Show Confirm', [{
					caption: propertyParams.options['displayAlways'] ? 'Clean element property' : 'Remove element property',
					message: propertyParams.options['displayAlways'] ? `Are you sure you want to clean element property "${propertyParams.title}"?` : `Are you sure you want to remove element property "${propertyParams.title}"? You will have possibility to add it again later.`,
					confirmButtonText: propertyParams.options['displayAlways'] ? '&nbsp;&nbsp;Clean property' : '&nbsp;&nbsp;Remove property',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {*/
						Server.sendToSocket({
							RevertElementProperty: {
								elementId: this.element.id,
								elementPropertyCodename: propertyParams.codename,
								sizeKey: Layout.getPreviewSizeKey()
							}
						});
					/*}
				}]);*/

			},
			toggleGlobalPropertyState(propertyParams) {

				Broadcast.call('Show Confirm', [{
					caption: 'Change element property global value state',
					message: `Are you sure you want to use global value for element property "${propertyParams.title}"? This will change the values of this property for all creative sizes.`,
					confirmButtonText: '&nbsp;&nbsp;Make global',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: !!this.element.options.globals?.[this.getBasePropertyCodename(propertyParams)] || Version.SelectedVersion?.options?.sizes?.length === 1 || propertyParams.options.globalByDefault,
					confirmCallback: () => {
						Server.sendToSocket({
							ToggleElementPropertyGlobalState: {
								elementId: this.element.id,
								elementPropertyCodename: propertyParams.codename,
								sizeKey: Layout.getPreviewSizeKey()
							}
						});
					}
				}]);

			},
			// Включение/выключение раздельного задания значения свойства для портретной и ландшафтной ориентаций.
			// При выключении значения для обеих ориентаций остаются в props, но перестают применяться
			togglePropertySplitState(propertyParams) {

				let baseCodename = this.getBasePropertyCodename(propertyParams);
				let split = this.isPropertySplit(propertyParams);

				Broadcast.call('Show Confirm', [{
					caption: 'Change element property orientation split state',
					message: split
						? `Are you sure you want to use a single value for element property "${propertyParams.title}" for both portrait and landscape orientations?`
						: `Are you sure you want to use different values for element property "${propertyParams.title}" for portrait and landscape orientations?`,
					confirmButtonText: split ? '&nbsp;&nbsp;Use single value' : '&nbsp;&nbsp;Split by orientation',
					confirmButtonIcon: split ? 'fa-compress' : 'fa-expand',
					confirmCallback: () => {
						Server.sendToSocket({
							ToggleElementPropertyPortraitLandscapeState: {
								elementId: this.element.id,
								elementPropertyCodename: baseCodename,
								sizeKey: Layout.getPreviewSizeKey()
							}
						});
					}
				}]);

			},
			openLocalization(messageKey) {

				if (!messageKey) return;

				if (!Layout.asideOpened) {

					Layout.toggleAside('settings');

				} else if (Layout.asideType !== 'settings') {

					Layout.asideType = 'settings';
					Broadcast.call('Aside Type Changed');

				}

				Layout.setSettingsTab('localization');

				Localization.requestedExpandedMessageKey = messageKey;

				Broadcast.call("Expand Localization Message", [messageKey]);

			},
			isDefaultValueChanged(element, propertyParams) {

				let defaultValue = propertyParams.default,
					currentValue = this.elementProps[propertyParams.codename];

				return (currentValue !== undefined) && !_.isEqual(defaultValue, currentValue);

			},
			blockUpdate() {

				// Запрещаем апдейт компонента пока фокус стоит в поле ввода информации
				this.updateBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;

				// Пробуем через таймаут обновить компонент
				// Если updateBlocked к этому моменту всё ещё будет false то компонент обновится и отобразит новые клиентские данные
				// Это делается чтобы заблокировать обновление полей ввода пока пользователь не завершил их ввод
				// Без этого автообновления мешают печатать новые значения в полях типа coords
				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

				}, 200);

			},
			checkOpen() {

				if (Layout.subAsideOpened) {

					if (!this.showed) {

						this.show();

						this.alpha = 0;
						this.right = 0;

						setTimeout(() => {
							this.alpha = 1;
							this.right = Layout.asideSize;
						}, 1);

					}

				}

				else {

					if (this.showed) {

						this.hide();

					}

				}

			},
			openPropertyAddMenu(e) {

				Broadcast.call("Show EditorElementInfoPropertiesAdd", [e.target.closest('.dropdown-element-property'), this.element, this.elementProps]);

			}
		}

	}
</script>

<style lang="sass">

	.element-properties
		background-color: #343b41
		color: #f3f4f5

		.cursor-container
			position: fixed
			z-index: 2
			left: 0
			top: 0
			width: 100%
			height: 100%
			cursor: move

		.header-container
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			height: 46px
			padding: 5px
			border-bottom: 1px solid #23282c
			cursor: default
			position: relative

			.drag-header


			.default-header
				display: flex
				flex-direction: column
				flex-wrap: nowrap
				align-items: center
				justify-content: center
				width: 100%

				.name
					color: #73818f
					display: flex
					padding: 0 5px

				.description
					font-size: 11px
					line-height: 1.2

			.revert-button
				right: 12px
				top: 12px
				border: none
				background: transparent
				font-size: 13px
				position: absolute
				cursor: pointer

				.fa
					color: rgba(255, 255, 255, 0.05)

				&:hover

					.fa
						color: #20a8d8

			.tutorial-text-header
				font-size: 12px
				color: var(--yellow)

			.tutorial-text-description
				color: var(--yellow)

		.props-container
			display: flex
			flex-direction: column

			.prop-item
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				min-height: 31px
				border-bottom: 1px solid #2e3235

				.title
					display: flex
					align-items: center
					justify-content: left
					width: 90px
					color: #73818f
					font-size: 0.75rem
					padding-left: 0.5rem
					cursor: default
					user-select: none
					white-space: nowrap

				.control
					display: flex
					align-items: center
					justify-content: left
					//width: 150px

					.control-number
						display: flex
						flex-direction: row
						flex-wrap: nowrap
						align-items: center
						justify-content: left

				.options
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					align-items: center
					justify-content: right
					width: auto
					margin-left: auto
					margin-right: 5px

					.option
						width: 15px
						height: 15px
						border: 1px solid rgba(255, 255, 255, 0.09)
						background-color: rgba(255, 255, 255, 0.05)
						border-radius: 0.1rem
						cursor: pointer
						margin-right: 2px

						&.remove, &.restore, &.global, &.localization, &.split
							border: none
							background: transparent
							font-size: 11px
							position: relative
							display: flex
							align-items: center

							.fa
								color: rgba(255, 255, 255, 0.05)

							&:hover

								.fa
									color: var(--secondary)

						&.localization
							font-size: 14px

							.fa
								color: rgba(255, 255, 255, 0.50)

							&:hover

								.fa
									color: #20a8d8

						&.remove
							font-size: 15px
							margin-right: 4px
							margin-top: -2px

						&.global
							font-size: 14px

							.fa-lock
								color: #20a8d8

						&.split
							font-size: 12px

							.fa-expand
								color: rgba(255, 255, 255, 0.25)

							.fa-compress
								color: #20a8d8

						&:last-child
							margin-right: 0

			.prop-item.change-process

				.title
					color: #20a8d8

			.properties-controls
				display: flex
				flex-direction: row
				justify-content: left
				padding-top: 10px
				border-top: 1px solid #2e3235

				.dropdown-element-property
					position: relative
					border: 1px solid rgba(255, 255, 255, 0.1)
					border-radius: 0.25rem
					background: rgba(255, 255, 255, 0.05) no-repeat
					background-position-x: right 0.75rem
					background-position-y: calc(50% - 1px)
					background-size: 8px 10px
					padding-top: 0.25rem
					padding-bottom: 0.25rem
					padding-right: 2rem
					padding-left: 0.5rem
					color: rgba(255, 255, 255, 0.5)
					cursor: pointer
					font-size: 0.765625rem
					margin-left: 5px

					&:hover
						border: 1px solid rgba(255, 255, 255, 0.3)
						background: rgba(255, 255, 255, 0.1) no-repeat

					.value
						max-width: 125px
						overflow: hidden
						text-overflow: ellipsis
						white-space: nowrap

					.drop-icon
						position: absolute
						right: 13px
						top: 8px
						color: rgba(255, 255, 255, 0.50)

				.dropdown-display-object-actions
					margin-left: auto
					margin-right: 5px

		.props-container.main-props

		.tmp

</style>
